import { InjectionToken } from '@angular/core';
import { ButtonType } from '../../components/button/button.component';

export const MODAL_NOTIFICATION_CONFIGURATION = new InjectionToken<TriggerConfiguration>('modalNotificationConfiguration');

export enum ModalIdLite {
  WELCOME_MODAL = 'welcome_modal_lite_new',
  WHATS_NEW = 'whats_new_lite',
  TRADECOUNT_RESET = 'tradecount_reset_lite',
  MONEY_TALK = 'money_talk_lite',
  FRACTIONAL_TRADING = 'fractional_trading_lite',
  CASH_RECURRING_TRANSFER = 'cash_recurring_transfer',
  OFI_RECURRING_TRANSFER = 'ofi_recurring_transfer',
  STOCK_CATEGORY = 'stock_category',
  FIRST_HOME_SAVING = 'first_home_saving',
  DRIPS = 'drips'
}

export enum ModalIdWB {
  FRACTIONAL_TRADING = 'fractional_trading',
  RECURRING_TRANSFERS = 'recurring_transfers',
  FHSA_ACCOUNT = 'fhsa_account',
  FHSA_RECURRING = 'fhsa_recurring',
  TRANSACTION_HISTORY = 'transaction_history',
  FULLY_PAID_LENDING = 'fully_paid_lending',
  DRIPS = 'drips',
  OFI_REGISTERED_ACCOUNTS = 'ofi_registered_accounts',
  NOTIFICATION_HUB = 'notification_hub',
  WHATS_NEW = 'whats_new',
  OFI_OPEN_BANKING = 'ofi_open_banking',
  RECURRING_INVESTMENTS = 'recurring_investments'
}

export type TriggerConfiguration = Record<string, ModalTriggerConfiguration>;

export interface ModalNotificationLauncher {
  getMatchedModalNotificationTrigger(): ModalTriggerConfiguration | undefined;
}

export interface ModalTriggerConfiguration {
  id: string;
  triggerLinkId: string | TriggerLinkIdType;
  persistence: TriggerType;
  modalType?: ModalType;
  contentURLs?: Array<string>;
  buttons?: Record<'left' | 'right', Array<Button>>;
}

export enum TriggerType {
  PER_USER = 'PER_USER',
  PER_SESSION = 'PER_SESSION'
}

export enum TriggerLinkIdType {
  ANY_URL = 'any'
}

export enum ModalType {
  STANDARD = 'STANDARD',
  WHATS_NEW = 'WHATS_NEW',
  YEARLY_EVENT = 'YEARLY_EVENT'
}

export interface Button {
  id: string;
  linkId: string;
  text: string;
  type: ButtonType;
}
